import { combineReducers } from 'redux'
import { reducers } from '@adc/ui-morpheus'
import { VENUE_TEMPLATE_CHANGES } from '../../constants/tableTypes'
import tableReducer from './columnDefinitions'

const venueTemplateHistoryReducer = (state, action) => {
  switch (action.type) {
    case `REPLACE_TABLE_USER_INFO_${VENUE_TEMPLATE_CHANGES}`:
      return reducers.dataTable.replaceTableUsersInfoReducer(
        VENUE_TEMPLATE_CHANGES,
        state,
        action
      )
    default:
      return reducers.auditTable.auditTableReducer(VENUE_TEMPLATE_CHANGES)(
        state,
        action
      )
  }
}
export default combineReducers({
  data: venueTemplateHistoryReducer,
  tableInfo: tableReducer,
  users: (state, action) =>
    reducers.dataTable.mappedUsersReducer(
      VENUE_TEMPLATE_CHANGES,
      state,
      action
    ),
})
